import Alarm from './Alarm';
import AlarmDevice from './AlarmDevice';
import CheckIn from './CheckIn';
import ContactUs from './ContactUs';
import Corporation from './Corporation';
import Facility from './Facility';
import Group from './Group';
import Module from './Module';
import MonitoredIndividual from './MonitoredIndividual';
import Mood from './Mood';
import Reports from './Reports';
import SocialEvent from './SocialEvent';
import StaffCheckHistoryNote from './StaffCheckHistoryNote';
import StatusSolutions from './StatusSolutions';
import Staging from './Staging';
import Survey from './Survey';
import Unit from './Unit';
import User from './User';
import UserMessage from './UserMessage';
import Weather from './Weather';

const base = {
  Alarm,
  AlarmDevice,
  CheckIn,
  ContactUs,
  Corporation,
  Facility,
  Group,
  Module,
  MonitoredIndividual,
  Mood,
  Reports,
  SocialEvent,
  StaffCheckHistoryNote,
  StatusSolutions,
  Staging,
  Survey,
  Unit,
  User,
  UserMessage,
  Weather
};
export default base;